export default __webpack_public_path__ + "static/media/Monk's Mask of the Nine Springs.40b81fc6.jpg";